import { Component, Input } from '@angular/core';
import { SupportService } from 'src/app/support.service';

@Component({
  selector: 'app-x-report',
  templateUrl: './x-report.component.html',
  styleUrls: ['./x-report.component.scss']
})
export class XReportComponent {
  @Input() date: Date = new Date();

  @Input() sum: number = 0;

  @Input() header: string = '';

  constructor(public supportService: SupportService) {}
}
